﻿import { eventBus } from '../../foundation/eventBus';
import { events as menuEvents } from './burger-menu';

export const offCanvasNav = () => {
    const selectors = {
        root: '.canvas',
        canvas: '.js-canvas-visible',
        canvasOpen: 'body-canvas--open',
        offCanvas: '.off-canvas',
        offCanvasOpen: 'off-canvas--open',
        listItem: '.primary-nav__item',
        listItemVisible: 'primary-nav__item--visible',
        listItemMenuToggleButton: '.primary-nav__sub-item-icon',
        menuGroup: '.primary-nav__item-group',
        menuGroupOpen: 'primary-nav__item-group--open',
        primaryNav: '.primary-nav'
    };

    var _addClassToEachItem = function () {
        var listItems = document.querySelectorAll(selectors.listItem);

        listItems.forEach(function(listItem){
            listItem.style.animationPlayState = 'paused';
            listItem.classList.add(selectors.listItemVisible);
        });
    };

    var _removeClassFromAllItems = function () {
        var navItems = document.querySelectorAll(`${selectors.primaryNav} ${selectors.listItem}`)

        navItems.forEach(function(element) {
            element.style.animationPlayState = 'paused';
            element.classList.remove(selectors.listItemVisible);
        });
    };

    var _toggleAccessibleHidden = function (el) {
        var primaryNav = el.closest(selectors.root).querySelector(selectors.primaryNav); 
        var elementAttribute = primaryNav.getAttribute('aria-hidden');

        // toggles the true or false state
        if(elementAttribute == 'true') {
            primaryNav.setAttribute('aria-hidden', 'false');
        }
        else {
            primaryNav.setAttribute('aria-hidden', 'true');
        }
    };
    
    var _toggleNavItems = function () {
        var open = document.querySelector(`.${selectors.canvasOpen}`);
        return !open ? _removeClassFromAllItems() : _addClassToEachItem();
    };

    var _toggleCanvasVisibility = function (el) {
        el.classList.toggle(selectors.canvasOpen);
        document.querySelector(selectors.offCanvas).classList.toggle(selectors.offCanvasOpen);
        _toggleNavItems();
        _toggleAccessibleHidden(el);
    };

    var _closeAllSubMenuItems = function() {
        var menuGroup = document.querySelectorAll(selectors.menuGroup);

        menuGroup.forEach(function(menu) {
            menu.classList.remove(selectors.menuGroupOpen);
            menu.nextElementSibling.style.display = 'none';
        });
      };

    var _openSubMenu = function (el) {
        var menuGroup = el.closest(selectors.menuGroup);
        menuGroup.classList.add(selectors.menuGroupOpen);
        menuGroup.nextElementSibling.style.display = 'block';
    }

    var _closeSubMenu = function (el) {
        var menuGroup = el.closest(selectors.menuGroup);
        menuGroup.classList.remove(selectors.menuGroupOpen);
        menuGroup.nextElementSibling.style.display = 'none';
    };

    var _toggleSubMenuItems = function () {

        var $item = document.querySelector(this);

        _closeAllSubMenuItems();

        if ($item.closest(selectors.menuGroup).nextElementSibling.matches(':visible')) {
            _closeSubMenu($item);
        } else { 
            _openSubMenu($item);
        }
    };

    var _bindEvents = function () {
        var menuButton = document.querySelector(selectors.listItemMenuToggleButton);
        if(menuButton){
            menuButton.addEventListener('click', function(){
                _toggleSubMenuItems();
            })
        }
    };

    const init = component => {
        _bindEvents();

        eventBus.subscribe(menuEvents.offCanvasNav, () => {
            _toggleCanvasVisibility(component);            
        });
    };

    return {
        init: init,
        selector: '.js-canvas-visible'
    };
}